import React from 'react';
import CrudTable, { ImageCell } from '../../components/admin/CrudTable';

export default function ManageProjects() {
  return (
    <CrudTable
      entity="projects"
      title="Layihələr"
      defaults={{ title: '', address: '', street: '', image: '', order: 0 }}
      fields={[
        { key: 'title', label: 'Ad', type: 'text' },
        { key: 'address', label: 'Ünvan', type: 'text' },
        { key: 'street', label: 'Küçə və ev', type: 'text' },
        { key: 'image', label: 'Səkil', type: 'image' },
        { key: 'order', label: 'Sıra', type: 'number' },
      ]}
      listColumns={[
        { key: 'image', label: 'Səkil', render: ImageCell },
        { key: 'title', label: 'Ad' },
        { key: 'address', label: 'Ünvan' },
        { key: 'order', label: 'Sıra' },
      ]}
    />
  );
}
